<div id="dashboard-wrapper">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div id="main-board" [ngClass]="{'patient': (roles$ | async).hasOwnProperty(PATIENT)}">
        <div id="main-content" role="main" tabindex="-1">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>
